import React, { useState,useEffect } from "react";
import { Link,useNavigate } from "react-router-dom";
import amaxLogo from "../../images/amaxLogo.png";
import arrowNext from "../../images/arrowNext.svg";
import API_URL from '../../api/API';


const CoachStep4 = () => {

  const navigate = useNavigate();
  // State for dropdown for category
  const [isOpen, setIsOpen] = useState(false);
  const [sport, setSport] = useState("Sport");
  const [organization,setOrganization] = useState('');
  const [number_of_atheletes,setNumberOfAthletes] = useState('');

  const [error, setError] = useState(null);
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const sportDropdownOptions = ["Sport", "Football", "Baseball"]; // Dropdown options


  const handleOptionClick = (option) => {
    setSport(option);
    setIsOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!sport || !organization || !number_of_atheletes) {
      setError('Please enter the details.');
      return;
    }

    setError(null);
    setMsg(null);
    setLoading(true);

    //now lets fetch all data from the session and build the API request to post the athlete registration details.
    const firstname = sessionStorage.getItem('firstname');
    const lastname = sessionStorage.getItem('lastname');
    const phonenumber = sessionStorage.getItem('phonenumber');
    const email = sessionStorage.getItem('email');
    const password = sessionStorage.getItem('password');
    const city = sessionStorage.getItem('city');
    const state = sessionStorage.getItem('state');
    const dob = sessionStorage.getItem('dob');
    const gender = sessionStorage.getItem('gender');
    
    try {
      const response = await fetch(API_URL.POST_CREATE_COACH, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({firstname,lastname,phonenumber,email,password,city,state,dob,gender,sport,organization,number_of_atheletes}),
      });

      const json = await response.json();
      setLoading(false);

      if (response.ok) {
          setMsg(json.message);
          sessionStorage.clear();
          setSport('Sport');
          setOrganization('');
          setNumberOfAthletes('');

      } 
      else 
      {
        // Display error returned by the server
        setError(json.error || 'An error occurred. Please try again.');
      }
    } catch (err) {
      setLoading(false);
      setError('Failed to connect to the server. Please try again.');
    }
  };


  return (
    <div className="p-[20px] bg-black h-dvh overflow-hidden">
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center gap-[160px] overflow-y-auto">
        <Link to="/" className="size-[96px] lg:size-[166px]">
          <img src={amaxLogo} alt="logo" className="object-contain" />
        </Link>
        <div className="flex flex-col gap-[50px] w-full">
          <div className="flex flex-col justify-center gap-[15px]">
            <h1 className="text-white text-[40px] leading-[95%] uppercase font-light">
              YOUR
              <br />
              TEAM INFO
            </h1>
            <div>
              <input
                type="text"
                className="border border-white focus:outline-none rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d] w-full mb-[15px]"
                placeholder="Team/Organization*"
                value={organization}
                onChange={(e) => setOrganization(e.target.value)}
              />
              <div className="relative mb-[15px]">
              <div
                  onClick={() => setIsOpen(!isOpen)}
                  className="bg-transparent text-white text-lg font-normal border border-white rounded-[45px] p-4 flex items-center justify-between cursor-pointer"
                >
                  {sport}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`transform transition-transform ${
                      isOpen ? "rotate-180" : "rotate-0"
                    }`}
                    width="14"
                    height="8"
                    viewBox="0 0 14 8"
                    fill="none"
                  >
                    <path
                      d="M1 0.999999L7 7L13 1"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                {isOpen && (
                  <div className="absolute bg-black border border-white rounded-md mt-2 w-full z-10">
                    {sportDropdownOptions.map((option) => (
                      <div
                        key={option}
                        onClick={() => handleOptionClick(option)}
                        className="px-4 py-2 cursor-pointer text-lg font-normal text-white hover:bg-white/50"
                      >
                        {option}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <input
                type="text"
                className="border border-white focus:outline-none rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d] w-full mb-[15px]"
                placeholder="Number of Athletes"
                value={number_of_atheletes}
                onChange={(e) => setNumberOfAthletes(e.target.value)}
              />
              
               {/* Display Loading Indicator */}
                {loading && (
                <p className="text-yellow-500 text-sm mt-2">
                  Processing request please wait...
                </p>
              )}

                 {/* Display Success Message */}
                 {msg && (
                <p className="text-green-500 text-sm mt-2">
                  {msg}
                </p>
              )}

                {/* Display Error Message */}
             {error && (
                  <p className="text-red-500 text-sm mt-2">
                    {error}
                  </p>
                )}


              <button
                type="button"
                onClick={handleSubmit}
                className="bg-white size-[70px] rounded-full flex justify-center items-center hover:bg-white/50 transition-all duration-300 ml-auto mt-[10px]"
              >
                <img src={arrowNext} alt="arrow" className="object-contain" />
              </button>
            
            </div>
          </div>
          <div className="flex flex-row justify-between items-center">
            <p className="text-white text-[30px] font-light uppercase leading-none">
              faster <br />
              <span className="font-bold">together.</span>
            </p>
          
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoachStep4;
